import { createStarryNight } from "@wooorm/starry-night";
//import { PapyrusTMLanguage } from "./Papyrus/papyrusTMLanguage";
import { memoizeDevServerConst } from "@/utils/memoizeDevServerConst";
import { UnreachableError } from "../../utils/UnreachableError";

declare global {
    interface Window {
        StarryNightInstance: ReturnType<typeof initStarryNightForReal>;
    }
    var StarryNightInstance: ReturnType<typeof initStarryNightForReal>; // eslint-disable-line vars-on-top
}


export enum CodeBlockLanguage {
    Papyrus = 'source.papyrus',
    JavaScript = 'source.js',
    TypeScript = 'source.ts',
}

const codeBlockLanguagesArr = Object.values(CodeBlockLanguage);
export const codeBlockLanguages = new Set(codeBlockLanguagesArr) as any as Omit<ReadonlySet<CodeBlockLanguage>, 'has'> & {
    has: (lang: string) => lang is CodeBlockLanguage;
};

export async function initStarryNightForReal() {
    return createStarryNight(await Promise.all(Object.values(CodeBlockLanguage).map(async lang => {
        switch (lang) {
            case CodeBlockLanguage.Papyrus: return (await import('./Papyrus/papyrusTMLanguage')).PapyrusTMLanguage;
            case CodeBlockLanguage.JavaScript: return (await import('@wooorm/starry-night/source.js')).default;
            case CodeBlockLanguage.TypeScript: return (await import('@wooorm/starry-night/source.ts')).default;
            default:
                throw new UnreachableError(lang, `No TextMate language definition found for language '${lang}'`);
        }
    })));
}

export async function getStarryNightInstance() {
    //return await initStarryNightForReal(); //-- use this when modifying any of the TextMate languages so your hot reloads work
    return await memoizeDevServerConst('initStarryNightForReal_ReturnValue_v2', initStarryNightForReal);
}

// TODO: Replace this with VS Code's own tokenization engine and just style it from there
// https://github.com/microsoft/vscode-textmate (or perhaps https://www.npmjs.com/package/@shikijs/vscode-textmate ?)
// needed WASM bindings: https://github.com/microsoft/vscode-oniguruma

// Also see:
// https://codesandbox.io/p/sandbox/vscode-textmate-forked-w5rg52
// https://classic.yarnpkg.com/en/package/monaco-textmate-provider
